import { Component, OnInit, OnDestroy } from '@angular/core';
import { AssistanceBasic } from 'src/app/models/helpbutton-models/helpbutton-assistance-basic.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ReportsHelpbuttonService } from 'src/app/services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-helpbutton-report-dashboard',
  templateUrl: './helpbutton-report-dashboard.component.html',
  styleUrls: ['./helpbutton-report-dashboard.component.scss']
})
export class HelpbuttonReportDashboardComponent implements OnInit, OnDestroy {

  assistance: AssistanceBasic;
  getAssistanceSubscription: Subscription;

  constructor(private router: Router,
              private reportsService: ReportsHelpbuttonService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getAssistanceDetail();
  }

  public getAssistanceDetail() {
      const internalId = this.activatedRoute.snapshot.params['reportid'];
      this.getAssistanceSubscription = this.reportsService.getAssistanceDetail(internalId).subscribe(
        (res) => {
          this.assistance = new AssistanceBasic();
          Object.assign(this.assistance, res['data']);
        },
        (error) => {
          this.router.navigate(['../../../reports'], {relativeTo: this.activatedRoute});
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-file', 'helpbutton-page.assistance detail', '/helpbutton/reports', [new BRoute('helpbutton-page.helpbutton', '/helpbutton'), new BRoute('helpbutton-page.assistance report', '/helpbutton/reports'), new BRoute('helpbutton-page.assistance detail')]));
  }

  ngOnDestroy() {
    if (this.getAssistanceSubscription) { this.getAssistanceSubscription.unsubscribe(); }
  }

}
